import React, { useEffect, useState } from "react";
import 'common/css/master.css';
import {  pdf } from '@react-pdf/renderer';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TestQuestionPDF from "./testQuestionsPDF";

import { getQuestionsSvc, getLogoSvc } from "./testQuestionsSvc";



const TestPDFSliderAndroid = (props) => {
    const { testId, testScheduleId, closeSlider, setLoader } = props;

    const [lstQuestions, setlstQuestions] = useState([]);
    const [testHeader, setTestHeader] = useState([]);
    const [logoUrl, setLogoUrl] = useState('');
    const [documentOpeningCalled, setDocumentLoadingCalled] = useState(false);



    useEffect(() => {
        // console.log("TestPDFSlider called");
        window.alert("opening TestPDFSlider in android browser");
        getTestQuestions(testId, testScheduleId);
        getLogoSvc(cbLogoResponse);
    }, [testId]);


    function cbLogoResponse(imageUrl) {
        // console.log("cbLogoResponse called, imageUrl", imageUrl);
        setLogoUrl(imageUrl)
    }

    const getTestQuestions = (pTestId, pTestScheduleId) => {
        // console.log("getTestQuestions called, testId passed", pTestId);
        getQuestionsSvc(pTestId, pTestScheduleId, getQuestionsResponse);
        setLoader("block");
    }

    const getQuestionsResponse = async (data) => {
        // console.log("getQuestionsResponse, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            // console.log("obj.lstQuestion", obj.lstQuestion);
            await setlstQuestions(obj.lstQuestion);
            await setTestHeader(obj.header);
            openDocument();
        }
        else {
            setLoader("none");
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
    }


    const openDocument = async () => {
        await setDocumentLoadingCalled(true);
        const document = await generateDocument();

        try {
            // Step 1: Generate the PDF Blob
            const blob = await pdf(document).toBlob();

            // Step 2: Check the file size (in bytes)
            const fileSizeInMB = blob.size / (1024 * 1024); // Size in MB

            // Define a threshold for the file size (for example, 10MB)
            const fileSizeThreshold = 10;

            if (fileSizeInMB > fileSizeThreshold) {
                // If file is too large, suggest downloading
                window.alert(`The file size is too large (${fileSizeInMB.toFixed(2)} MB). It may be slow to open. Downloading instead...`);

                // Force download if file is too large
                const downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = 'weeklyTest.pdf';
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else {
                // Step 3: Attempt to open the PDF in a new tab
                const fileURL = URL.createObjectURL(blob);
                const newTab = window.open(fileURL, '_blank');

                // Step 4: Check if the tab was successfully opened
                if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                    window.alert('Popup blocked. Downloading file instead...');
                    const downloadLink = document.createElement('a');
                    downloadLink.href = fileURL;
                    downloadLink.download = 'weeklyTest.pdf'; // Set default filename
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            }
        } catch (error) {
            window.alert('Error opening or downloading PDF:', error);
        }

        setLoader("none");
    };


    const generateDocument = () => new Promise((resolve) => {
        const generatedDocument = (
            <TestQuestionPDF
                logoUrl={logoUrl}
                subject={testHeader.test || ""}
                clsSec={testHeader.clsSection || ""}
                school={testHeader.school || ""}
                academicYear={testHeader.acdYr || ""}
                duration={testHeader.durationMins || ""}
                questionCount={testHeader.noOfQus || ""}
                lstQuestions={lstQuestions}
                flgAnswerBox={!testHeader.separateAnsSheet}
            />
        );
        resolve(generatedDocument);
    });

    return (
        <div>
        </div>
    );
}
export default TestPDFSliderAndroid;